<template>
  <van-dialog title="编辑" v-model="show" :show-cancel-button="true" cancel-button-text="取消" confirm-button-text="确定" type="danger" class-name="pc-dialog pc-gg-dialog" :before-close="handleSubmit">
    <div class="setting-component-container">
      <div class="column-item">
        <div class="title-item">手机号</div>
        <div class="input-item">
          <div class="input"><input v-model="from.Phone" type="text" placeholder="请输入手机号" /></div>
        </div>
      </div>
      <div class="column-item">
        <div class="title-item">验证码</div>
        <div class="input-item">
          <div class="input"><input v-model="from.CaptchaValue" type="text" placeholder="请输入验证码" /></div>
          <div class="code-img img-cover">
            <img v-if="captchaPath" :src="captchaPath" @click="handleGetCaptcha" />
          </div>
        </div>
      </div>
      <div class="column-item">
        <div class="title-item">短信验证码</div>
        <div class="input-item">
          <div class="input"><input v-model="from.Vcode" type="text" placeholder="短信验证码" /></div>
          <div class="send-code" :class="time > 0 ? 'not' : ''" @click="getMsg">{{ time > 0 ? `${time}s` : '发送验证码' }}</div>
        </div>
      </div>
    </div>
  </van-dialog>
</template>

<script>
import { mapState } from 'vuex'
export default {
  emits: ['success', 'close'],
  name: "SettingPhoneComponent",
  data() {
    return {
      show: false,
      captchaPath: '',
      timer: null,
      time: 0,
      from: {
        Phone: '',
        CaptchaValue: '',
        Vcode: '',
      }
    }
  },
  computed: {
    ...mapState(['userInfo', 'websiteInfo'])
  },
  methods: {
    open() {
      this.show = true
      this.handleGetCaptcha()
    },
    handleGetCaptcha() {
      this.captchaPath = this.$HTTP.baseURL + '/common/captcha?v=' + (new Date().getTime())
    },
    async getMsg() {
      const { from, time, timer } = this
      if (time > 0 || timer != null) {
        return
      }
      if (!from.Phone) {
        this.$toast('请输入手机号')
        return
      }
      if (!from.CaptchaValue) {
        this.$toast('请输入您的验证码')
        return
      }
      var res = await this.$API.sendMsg.post({
        Phone: from.Phone,
        CaptchaValue: from.CaptchaValue,
      })
      if (res.error == 0) {
        this.setTimer()
      } else {
        this.$dialog.alert({
          type: 'danger',
          className: 'pc-dialog',
          title: '提示',
          message: res.info,
          confirmButtonText: '确定',
        })
        this.handleGetCaptcha()
      }
    },
    setTimer() {
      if (this.timer != null) {
        clearInterval(this.timer)
      }
      let t = 60
      this.time = t
      this.timer = setInterval(() => {
        t--
        this.time = t
        if (t <= 0) {
          clearInterval(this.timer)
        }
      }, 1000);
    },
    async handleSubmit(action, done) {
      if (action == 'cancel') {
        this.$emit('onClose')
        done()
        return
      }
      if (action == 'confirm') {
        const { from } = this
        if (!from.Phone) {
          this.$toast('请输入手机号')
          return
        }
        if (!from.Vcode) {
          this.$toast('请输入您的验证码')
          return
        }
        this.submiting = true
        var res = await this.$API.updatePhone.post({
          Phone: from.Phone,
          Vcode: from.Vcode,
        })
        this.submiting = false
        if (res.error == 0) {
          this.$toast.success(res.info)
          this.show = false
          this.$emit('success')
          done()
        } else {
          this.$dialog.alert({
            type: 'danger',
            className: 'pc-dialog',
            title: '提示',
            message: res.info,
            confirmButtonText: '确定',
          })
          done(false)
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
.setting-component-container {
  padding: 0 15px;
}
.column-item {
  margin-bottom: 20px;
  overflow: hidden;
  .title-item {
    padding-left: 18px;
    position: relative;
    height: 28px;
    line-height: 28px;
    font-size: 18px;
    font-weight: 500;
    color: #393942;
    margin-bottom: 15px;
    &::before {
      content: '';
      position: absolute;
      top: 4px;
      left: 0;
      width: 3px;
      height: 20px;
      border-radius: 0 2px 2px 0;
      background-color: #5783fc;
    }
  }
  .input-item {
    display: flex;
    align-items: center;
    padding-left: 15px;
    border-radius: 5px;
    background-color: #f7f7f7;
    height: 40px;
    overflow: hidden;
  }
  .input {
    flex: 1;
    height: 100%;
    margin-right: 15px;
  }
  .code-img {
    width: 100px;
    height: 40px;
    cursor: pointer;
  }
  .send-code {
    cursor: pointer;
    color: #5783fc;
    margin-right: 15px;
    font-size: 12px;
    &.not {
      color: #64748b;
    }
  }
}
</style>